<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12">
          <h5>Staff Photos</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row">
          <!-- Staff Search -->
          <div class="col-md-6 col-12 mb-2 ml-auto">
            <div class="text-right mb-3">
              <a-input-search
                placeholder="Search Staffs.."
                size="large"
                v-model="search"
                @search="searchStaffs"
                @change="searchStaffs"
              />
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <staff-photo-upload :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right mt-3">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          />
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import StaffPhotoUpload from '@/components/staff/PhotoUpload/index'
import { debounce } from 'lodash'

export default {
  components: {
    StaffPhotoUpload,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('staffphotos', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    }).catch(() => {
      // Fallback permission allowing viewable if roleutility fails
      this.pagepermission = { insertable: true, editable: true, viewable: true, deletable: true }
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getStaffs()
  },
  created() {
    this.searchStaffs = debounce(this.searchStaffs, 500)
  },
  data: function() {
    return {
      loading: true,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      search: null,
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getStaffs: function(isSearch) {
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/staff', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta || { total: data.data ? data.data.length : 0 }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    searchStaffs: function(e) {
      this.search = e.target.value
      this.getStaffs(true)
    },
    handleUpdateTable: function() {
      this.getStaffs()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStaffs()
    },
    onChange(current) {
      this.current = current
      this.getStaffs()
    },
  },
}
</script>
